<template>
  <DateTimePicker
    ref="el"
    placeholder=""
    :inline="inline"
    :default-date="Object.values(value)"
    :disable="disable"
    mode="range"
    @input="change"
    @close="close"
  />
</template>

<script>
import DateTimePicker from './DateTimePicker'

export default {
  components: {
    DateTimePicker,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    disable: { type: Array, default: () => ([]) },
  },

  watch: {
    value (newValue) {
      if (!newValue.fromDate && !newValue.toDate) {
        this.$refs.el.flatpickr.clear()
      }
    }
  },

  methods: {
    change (value) {
      const dates = value.split(' ')
      let dateRange = {}

      if (dates.length === 3) {
        dateRange = {
          fromDate: dates[0],
          toDate: dates[2]
        }
      } else if (dates.length === 1) {
        dateRange = {
          fromDate: value,
          toDate: value
        }
      }

      this.$emit('change', dateRange)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
